// extracted by mini-css-extract-plugin
module.exports = {"additionalNotes":"_37EkH"};